import { access } from "../utils/access";

export const getAccessPrivilegeObject = () => {
    const object: Record<string, string[]> = {}; // We still use object, but now we preserve order.
        Object.keys(access).forEach((item) => {
      object[item] = Object.keys(access[item as keyof typeof access]);
    });
    return object;
  };